import { ProductData } from "@/common/types/product.type";
import { ProductCategoryData } from "@/common/types/productCategory.type";
import { z } from "zod";
import { GovernmentAllocationMovementsKind } from "../types/companyGovernmentAllocation.type";

export const productDistribution = z.object({
  id: z.string().optional().nullable(),
  product: z.custom<ProductData>(),
  total_value: z.string().optional().nullable(),
});

export const productCategoryDistributionSchema = z.object({
  id: z.string().optional().nullable(),
  product_category: z.custom<ProductCategoryData>(),
  total_value: z.string().optional().nullable(),
  products_distributions: z.array(productDistribution),
});

export const createGovernmentAllocationDistributionSchema = z.object({
  movements_kind: z.custom<GovernmentAllocationMovementsKind>(),
  total_value: z.string().optional().nullable(),
  product_categories_distributions: z.array(productCategoryDistributionSchema),
}).superRefine((arg, ctx) => {
  if (arg.movements_kind !== 'fee' && arg.product_categories_distributions.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['product_categories_distributions'],
      message: 'Pelo menos um serviço deve ser adicionado',
    });
  }
});

export const productDistributionQuantity = z.object({
  id: z.string().optional().nullable(),
  product: z.custom<ProductData>(),
  total_quantity: z.string().optional().nullable(),
});

export const productCategoryDistributionQuantitySchema = z.object({
  id: z.string().optional().nullable(),
  product_category: z.custom<ProductCategoryData>(),
  total_quantity: z.string().optional().nullable(),
  products_distributions: z.array(productDistributionQuantity),
});

export const createGovernmentAllocationDistributionQuantitySchema = z.object({
  movements_kind: z.custom<GovernmentAllocationMovementsKind>(),
  total_quantity: z.string().optional().nullable(),
  product_categories_distributions: z.array(productCategoryDistributionQuantitySchema),
}).superRefine((arg, ctx) => {
  if (arg.movements_kind !== 'fee' && arg.product_categories_distributions.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['product_categories_distributions'],
      message: 'Pelo menos um serviço deve ser adicionado',
    });
  }
});

export type GovernmentAllocationProductDistributionValidationSchema = z.infer<typeof productDistribution>;
export type GovernmentAllocationProductCategoryDistributionValidationSchema = z.infer<typeof productCategoryDistributionSchema>;
export type CreateGovernmentAllocationDistributionValidationSchema = z.infer<typeof createGovernmentAllocationDistributionSchema>;

export type GovernmentAllocationProductDistributionQuantityValidationSchema = z.infer<typeof productDistributionQuantity>;
export type GovernmentAllocationProductCategoryDistributionQuantityValidationSchema = z.infer<typeof productCategoryDistributionQuantitySchema>;
export type CreateGovernmentAllocationDistributionQuantityValidationSchema = z.infer<typeof createGovernmentAllocationDistributionQuantitySchema>;
